const getters = {
  getLastOrder(state) {
    return state.lastOrder ? state.lastOrder : {};
  },
  getOrderPayment(state) {
    return state.currentOrderPayment ? state.currentOrderPayment : {};
  },
  getOrders(state) {
    return state.orders.sort((a, b) => {
      let dateA: any = new Date(a.created_at);
      let dateB: any = new Date(b.created_at);
      return dateB - dateA;
    });
  },
  getNotTerminalOrders(state, getters) {
    return getters.getOrders
      .filter((element) => {
        return (
          element.status !== "order_completed" &&
          element.status !== "order_canceled_by_restaurant" &&
          element.status !== "order_canceled_in_handoff" &&
          element.status !== "order_canceled_by_troubleshooting_delivery_man"
        );
      })
      .sort((a, b) => {
        return b.id - a.id;
      });
  },
  getTerminalOrders(state, getters) {
    return getters.getOrders
      .filter((element) => {
        return (
          element.status === "order_completed" ||
          element.status === "order_canceled_by_restaurant" ||
          element.status === "order_canceled_in_handoff" ||
          element.status === "order_canceled_by_troubleshooting_delivery_man"
        );
      })
      .sort((a, b) => {
        return b.id - a.id;
      });
  },
  getCurrentOrder(state) {
    return state.currentOrder;
  },
  getDeliveryMan(state, getters) {
    if (getters.getCurrentOrder) {
      if (getters.getCurrentOrder.is_takeout || !getters.getCurrentOrder.delivery.delivery_man) {
        return "not name";
      } else {
        return `${getters.getCurrentOrder.delivery.delivery_man.first_name} ${getters.getCurrentOrder.delivery.delivery_man.last_name}`;
      }
    }
  },
  getOrdersMeta(state) {
    return state.ordersMeta;
  },
  getOpenCashbackModal(state) {
    return state.openCashbackModal;
  },
};

export default getters;
